export default "__VITE_ASSET__8XUObqGJ__"